import jwt from 'jwt-decode'
import {clearSession, writeNewToken} from "../service/authService/AuthService";

export const actionTypes = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
}

export const initialState = {
    loading: true,
    role: []
}

export function reducer(state, action) {

    switch (action.type) {
        case actionTypes.LOGIN: {
            writeNewToken(action.token)
            return {
                ...state,
                loading: false,
                loginState: true,
                role: prepareRoles(action.token),
            }
        }
        case actionTypes.LOGOUT: {
            clearSession()
            return {
                ...state,
                loading: false,
                loginState: false,
                role: []
            }
        }
        default: {
            clearSession()
            return {
                ...state,
                loading: false,
                loginState: false,
                role: []
            }
        }
    }
}

export function setLoginStateDispatch(actionType, token = null) {
    return {
        type: actionType,
        token: token
    }
}

export function prepareRoles(token) {
    const encoded = jwt(token)
    if (encoded && encoded.authorities)
        return [...encoded.authorities.map(item => {
            return item
        })]
    else
        return []
}


export const AdminRoles = {
    "SUPER_ADMIN": {
        role: "SUPER_ADMIN",
        name: "مدیر کل"
    }, "FUND_MANAGER": {
        role: "FUND_MANAGER",
        name: "مدیر صندوق"
    }, "SITE_MANAGER": {
        role: "SITE_MANAGER",
        name: "مدیر سایت"
    }, "READ_ADMINS_LIST": {
        role: "READ_ADMINS_LIST",
        name: "خواندن لیست مدیران"
    }, "READ_FILES_LIST": {
        role: "READ_FILES_LIST",
        name: ""
    }, "READ_ADMIN_OWN_INFORMATION": {
        role: "READ_ADMIN_OWN_INFORMATION",
        name: ""
    }, "READ_LOCATIONS_LIST": {
        role: "READ_LOCATIONS_LIST",
        name: ""
    }, "READ_LOCATION_CATEGORY_TREE": {
        role: "READ_LOCATION_CATEGORY_TREE",
        name: ""
    }, "CREATE_ADMIN_ROLE": {
        role: "CREATE_ADMIN_ROLE",
        name: ""
    }, "READ_LANGUAGES_LIST": {
        role: "READ_LANGUAGES_LIST",
        name: ""
    }, "READ_RESIDENCES_LIST": {
        role: "READ_RESIDENCES_LIST",
        name: ""
    }, "READ_ACCOMMODATION_PERIODS_LIST": {
        role: "READ_ACCOMMODATION_PERIODS_LIST",
        name: ""
    }, "READ_ITIKAF_PERIOD_INFORMATION": {
        role: "READ_ITIKAF_PERIOD_INFORMATION",
        name: ""
    },
}